import { authActions } from "./features/authReducer";
import { cellListActions } from "./features/cellListReducer";
import { facilityListActions } from "./features/facilityListReducer";
import { userSelectionActions } from "./features/userSelectionReducer";
import { deleteSession } from "../services/sessionAPI";
import { clearTokens } from "../services/tokenStore";

/**
 * Shared logout side-effects; kept out of clientAPI to avoid a load-time import cycle (reducers → APIClient → hook → reducers).
 *
 * `forced` marks a logout the session ended on its own (expired token, failed refresh) rather
 * than the header's Logout, which warns first. The auth reducer keeps line drafts that are
 * mid-Save on a forced logout (LT-3597); everything else is identical.
 */
export async function dispatchAppLogout(dispatch: any, apiURL?: string, options: { forced?: boolean } = {}): Promise<void> {
    // Destroy the server-side session BEFORE navigating — a fire-and-forget
    // DELETE can be cancelled by the redirect, orphaning the cookie and the
    // ui.console_session row. Cap the wait so a dead server can't hang logout.
    if (apiURL) {
        await Promise.race([
            deleteSession(apiURL),
            new Promise((resolve) => setTimeout(resolve, 3000)),
        ]);
    }
    clearTokens();
    dispatch(authActions.logout({ forced: !!options.forced }));
    dispatch(cellListActions.logout());
    dispatch(facilityListActions.logout());
    dispatch(userSelectionActions.logout());
}
